export const getRadianAngle = (degreeValue: number): number =>
  (degreeValue * Math.PI) / 180;
